/**
 * City Data for SEO-Friendly URLs
 * Maps city slugs to their coordinates for geolocation-based filtering
 */

export interface CityInfo {
  name: string;
  slug: string;
  lat: number;
  lng: number;
  state?: string;
}

export const CITY_DATA: Record<string, CityInfo> = {
  // Metro Cities
  'bangalore': { name: 'Bangalore', slug: 'bangalore', lat: 12.9716, lng: 77.5946, state: 'Karnataka' },
  'mumbai': { name: 'Mumbai', slug: 'mumbai', lat: 19.0760, lng: 72.8777, state: 'Maharashtra' },
  'delhi': { name: 'Delhi', slug: 'delhi', lat: 28.6139, lng: 77.2090, state: 'Delhi' },
  'chennai': { name: 'Chennai', slug: 'chennai', lat: 13.0827, lng: 80.2707, state: 'Tamil Nadu' },
  'kolkata': { name: 'Kolkata', slug: 'kolkata', lat: 22.5726, lng: 88.3639, state: 'West Bengal' },
  'hyderabad': { name: 'Hyderabad', slug: 'hyderabad', lat: 17.3850, lng: 78.4867, state: 'Telangana' },
  
  // Tier 1 Cities
  'pune': { name: 'Pune', slug: 'pune', lat: 18.5204, lng: 73.8567, state: 'Maharashtra' },
  'ahmedabad': { name: 'Ahmedabad', slug: 'ahmedabad', lat: 23.0225, lng: 72.5714, state: 'Gujarat' },
  'jaipur': { name: 'Jaipur', slug: 'jaipur', lat: 26.9124, lng: 75.7873, state: 'Rajasthan' },
  'lucknow': { name: 'Lucknow', slug: 'lucknow', lat: 26.8467, lng: 80.9462, state: 'Uttar Pradesh' },
  'chandigarh': { name: 'Chandigarh', slug: 'chandigarh', lat: 30.7333, lng: 76.7794, state: 'Chandigarh' },
  'kochi': { name: 'Kochi', slug: 'kochi', lat: 9.9312, lng: 76.2673, state: 'Kerala' },
  'goa': { name: 'Goa', slug: 'goa', lat: 15.2993, lng: 74.1240, state: 'Goa' },
  'indore': { name: 'Indore', slug: 'indore', lat: 22.7196, lng: 75.8577, state: 'Madhya Pradesh' },
  'nagpur': { name: 'Nagpur', slug: 'nagpur', lat: 21.1458, lng: 79.0882, state: 'Maharashtra' },
  'bhopal': { name: 'Bhopal', slug: 'bhopal', lat: 23.2599, lng: 77.4126, state: 'Madhya Pradesh' },
  
  // Tier 2 Cities
  'surat': { name: 'Surat', slug: 'surat', lat: 21.1702, lng: 72.8311, state: 'Gujarat' },
  'vadodara': { name: 'Vadodara', slug: 'vadodara', lat: 22.3072, lng: 73.1812, state: 'Gujarat' },
  'coimbatore': { name: 'Coimbatore', slug: 'coimbatore', lat: 11.0168, lng: 76.9558, state: 'Tamil Nadu' },
  'visakhapatnam': { name: 'Visakhapatnam', slug: 'visakhapatnam', lat: 17.6868, lng: 83.2185, state: 'Andhra Pradesh' },
  'mysore': { name: 'Mysore', slug: 'mysore', lat: 12.2958, lng: 76.6394, state: 'Karnataka' },
  'thiruvananthapuram': { name: 'Thiruvananthapuram', slug: 'thiruvananthapuram', lat: 8.5241, lng: 76.9366, state: 'Kerala' },
  'patna': { name: 'Patna', slug: 'patna', lat: 25.5941, lng: 85.1376, state: 'Bihar' },
  'ranchi': { name: 'Ranchi', slug: 'ranchi', lat: 23.3441, lng: 85.3096, state: 'Jharkhand' },
  'bhubaneswar': { name: 'Bhubaneswar', slug: 'bhubaneswar', lat: 20.2961, lng: 85.8245, state: 'Odisha' },
  'guwahati': { name: 'Guwahati', slug: 'guwahati', lat: 26.1445, lng: 91.7362, state: 'Assam' },
  'dehradun': { name: 'Dehradun', slug: 'dehradun', lat: 30.3165, lng: 78.0322, state: 'Uttarakhand' },
  'amritsar': { name: 'Amritsar', slug: 'amritsar', lat: 31.6340, lng: 74.8723, state: 'Punjab' },
  'ludhiana': { name: 'Ludhiana', slug: 'ludhiana', lat: 30.9010, lng: 75.8573, state: 'Punjab' },
  'varanasi': { name: 'Varanasi', slug: 'varanasi', lat: 25.3176, lng: 82.9739, state: 'Uttar Pradesh' },
  'agra': { name: 'Agra', slug: 'agra', lat: 27.1767, lng: 78.0081, state: 'Uttar Pradesh' },
  'kanpur': { name: 'Kanpur', slug: 'kanpur', lat: 26.4499, lng: 80.3319, state: 'Uttar Pradesh' },
  'noida': { name: 'Noida', slug: 'noida', lat: 28.5355, lng: 77.3910, state: 'Uttar Pradesh' },
  'gurgaon': { name: 'Gurgaon', slug: 'gurgaon', lat: 28.4595, lng: 77.0266, state: 'Haryana' },
  'faridabad': { name: 'Faridabad', slug: 'faridabad', lat: 28.4089, lng: 77.3178, state: 'Haryana' },
  'udaipur': { name: 'Udaipur', slug: 'udaipur', lat: 24.5854, lng: 73.7125, state: 'Rajasthan' },
  'jodhpur': { name: 'Jodhpur', slug: 'jodhpur', lat: 26.2389, lng: 73.0243, state: 'Rajasthan' },
  'mangalore': { name: 'Mangalore', slug: 'mangalore', lat: 12.9141, lng: 74.8560, state: 'Karnataka' },
  'hubli': { name: 'Hubli', slug: 'hubli', lat: 15.3647, lng: 75.1240, state: 'Karnataka' },
  'ballari': { name: 'Ballari', slug: 'ballari', lat: 15.1394, lng: 76.9214, state: 'Karnataka' },
};

// Helper function to get city by slug
export const getCityBySlug = (slug: string): CityInfo | undefined => {
  return CITY_DATA[slug.toLowerCase()];
};

// Get all city names for autocomplete
export const getAllCityNames = (): string[] => {
  return Object.values(CITY_DATA).map(city => city.name);
};

// Get all city slugs
export const getAllCitySlugs = (): string[] => {
  return Object.keys(CITY_DATA);
};

// Default radius for SEO URLs (in km)
export const DEFAULT_SEO_RADIUS = 50;
